import { render, staticRenderFns } from "./dashboard-app.vue?vue&type=template&id=3b82265e&"
import script from "./dashboard-app.component.ts?vue&type=script&lang=ts&"
export * from "./dashboard-app.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports